type OnboardingLinkEvent = 'page_view' | 'whatsapp_tap';
type OnboardingLinkPage = 'app_ref' | 'app_join';

export const sendOnboardingLinkEvent = (
  code: string,
  event: OnboardingLinkEvent,
  page: OnboardingLinkPage,
) => {
  const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  void fetch(`${apiBase}/onboarding-link-events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, event, page }),
    keepalive: true,
  }).catch(() => {});
};
